import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byName',
  pure: false,
  standalone: false
})
export class ByNamePipe implements PipeTransform {
  public transform(items: any[], name: string): any[] {
    return name && name.trim()
      ? items.filter((item) => item.Name.toLowerCase().indexOf(name.toLowerCase()) !== -1)
      : items;
  }
}
